import * as React from 'react';
import {
  H2,
  H4,
  Notice,
  NoticeIcon,
  SearchButton,
  SearchImage,
  SearchInput,
  SearchTextWrap,
  SearchWrap,
} from './styles';
import searchImg from '../../../assets/Pngtree—cartoon.png';

export const SearchToViewTimetable = ({
  searchValue,
  setSearchValue,
  handleSubmit,
}: {
  searchValue: string;
  setSearchValue: React.Dispatch<React.SetStateAction<string>>;
  handleSubmit: () => void;
}): JSX.Element => {
  return (
    <form
      className="w-full"
      onSubmit={(e) => {
        e.preventDefault();
        handleSubmit();
      }}
    >
      <SearchWrap>
        <SearchImage src={searchImg} alt="search-img" />
        <SearchTextWrap>
          <H4>Get your</H4>
          <H2>Invigilation Schedule</H2>
          <H4>Below</H4>
          <SearchInput
            value={searchValue}
            onChange={(e) => setSearchValue(e.target.value)}
            placeholder="Please enter your name as it appears on the time table"
          />
          <SearchButton type="submit" onClick={handleSubmit}>
            Search
          </SearchButton>
          <Notice>
            <NoticeIcon className="fas fa-info-circle" /> Contact the Examinations Officer or visit
            the examinations office to resolve all issues
          </Notice>
        </SearchTextWrap>
      </SearchWrap>
    </form>
  );
};
